import React from "react";
import { useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react"; // Import Swiper and SwiperSlide
import "swiper/css"; // Import Swiper core styles
import "swiper/css/navigation"; // Import Swiper navigation styles
import { Navigation } from "swiper/modules"; // Import Navigation module
import { useTranslation } from 'react-i18next';
// import ArrowLine from '../../../../../images/home/grsf/icon/3.json'

import { DotLottieReact } from '@lottiefiles/dotlottie-react';

const Grsf = () => {
  const { t } = useTranslation();

  return (
    <section className="lyt-section typ-why-choose-section container">
      <div className="container">
        <div className="heading-wrapper justify-content-center">
          <div className="text-center">
            <h2
              className="bs-heading typwhite"
              data-aos="fade-in"
              data-aos-delay="200"
            >
              {t('whyChooseGRSF')}              
            </h2>
          </div>
        </div>

        {/* Swiper container for sliding boxes */}
        <div className="bs-swiper typ-grsf-logo">
          <Swiper
            modules={[Navigation]} // Enable Navigation module
            spaceBetween={30}
            slidesPerView={3}
            loop={true}
            navigation={{
              prevEl: ".previous",
              nextEl: ".next",
            }}
            breakpoints={{
              320: {
                slidesPerView: 1,
              },
              768: {
                slidesPerView: 2,
              },
              1024: {
                slidesPerView: 2,
              },
            }}
            className="swiper-container"
          >
            <SwiperSlide>
              <div className="box">
                <div className="box-icon">
                  <DotLottieReact
                    src="/images/home/grsf/icon/1.json"
                    loop
                    autoplay
                    style={{ width: '60px', height: '60px' }}
                  ></DotLottieReact>


                </div>
                <div className="box-content">
                  <div className="title">{t('boxContentTitle8')}</div>
                  <div className="description">
                     { t('boxContentDesc8')}
                  </div>
                </div>
              </div>
            </SwiperSlide>



            <SwiperSlide>
              <div className="box">
                <div className="box-icon">
                  <DotLottieReact
                    src="/images/home/grsf/icon/2.json"
                    loop
                    autoplay
                    style={{ width: '60px', height: '60px' }}
                  ></DotLottieReact>
                </div>
                <div className="box-content">
                  <div className="title">{t('boxContentTitle7')}</div>
                  <div className="description">
                  { t('boxContentDesc7')}
                  </div>
                </div>
              </div>
            </SwiperSlide>

            <SwiperSlide>
              <div className="box">
                <div className="box-icon">

                  <DotLottieReact
                    src="/images/home/grsf/icon/3.json"
                    loop
                    autoplay
                    style={{ width: '60px', height: '60px' }}
                  ></DotLottieReact>
                </div>
                <div className="box-content">
                  <div className="title">{t('boxContentTitle6')}</div>
                  <div className="description">
                    { t('boxContentDesc6')}
                  </div>
                </div>
              </div>
            </SwiperSlide>

            <SwiperSlide>
              <div className="box">
                <div className="box-icon">
                  <DotLottieReact
                    src="/images/home/grsf/icon/4.json"
                    loop
                    autoplay
                    style={{ width: '60px', height: '60px' }}
                  ></DotLottieReact>
                </div>
                <div className="box-content">
                  <div className="title">{t('boxContentTitle5')}</div>
                  <div className="description">
                   { t('boxContentDesc5')}
                  </div>
                </div>
              </div>
            </SwiperSlide>

            <SwiperSlide>
              <div className="box">
                <div className="box-icon">
                  <DotLottieReact
                    src="/images/home/grsf/icon/5.json"
                    loop
                    autoplay
                    style={{ width: '60px', height: '60px' }}
                  ></DotLottieReact>
                </div>
                <div className="box-content">
                  <div className="title">{t('boxContentTitle4')}</div>
                  <div className="description">
                   { t('boxContentDesc4')}
                  </div>
                </div>
              </div>
            </SwiperSlide>

            <SwiperSlide>
              <div className="box">
                <div className="box-icon">
                  <DotLottieReact
                    src="/images/home/grsf/icon/6.json"
                    loop
                    autoplay
                    style={{ width: '60px', height: '60px' }}
                  ></DotLottieReact>
                </div>
                <div className="box-content">
                  <div className="title">{t('boxContentTitle3')}</div>
                  <div className="description">
                    { t('boxContentDesc3')}
                  </div>
                </div>
              </div>
            </SwiperSlide>

            <SwiperSlide>
              <div className="box">
                <div className="box-icon">
                  <DotLottieReact
                    src="/images/home/grsf/icon/7.json"
                    loop
                    autoplay
                    style={{ width: '60px', height: '60px' }}
                  ></DotLottieReact>
                </div>
                <div className="box-content">
                  <div className="title">{t('boxContentTitle2')}</div>
                  <div className="description">
                     { t('boxContentDesc2')}
                  </div>
                </div>
              </div>
            </SwiperSlide>

            <SwiperSlide>
              <div className="box">
                <div className="box-icon">
                  <DotLottieReact
                    src="/images/home/grsf/icon/8.json"
                    loop
                    autoplay
                    style={{ width: '60px', height: '60px' }}
                  ></DotLottieReact>
                </div>
                <div className="box-content">
                  <div className="title">{t('boxContentTitle1')}</div>
                  <div className="description">
                   { t('boxContentDesc1')}
                  </div>
                </div>
              </div>
            </SwiperSlide>

            {/* <SwiperSlide>
              <div className="box">
                <div className="box-icon">
                  <DotLottieReact
                    src="/images/home/grsf/icon/9.json"
                    loop
                    autoplay
                    style={{ width: '60px', height: '60px' }}
                  ></DotLottieReact>
                </div>
                <div className="box-content">
                  <div className="title">Revenue-Generating and Self-Sustaining Model</div>
                  <div className="description">
                    Access to a curated network of developers, PMCs, architects, legal experts, and financial institutions for expert project support.
                  </div>
                </div>
              </div>
            </SwiperSlide> */}
          </Swiper>

          {/* Custom navigation buttons */}
          <div className="swiper-button-prev previous">
            <span className="icon icon-right-arrow"></span>
          </div>
          <div className="swiper-button-next next">
            <span className="icon icon-right-arrow"></span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Grsf;
